import React, { useState } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import heroimg from "../assets/hero.png"
import { Link } from 'react-router-dom';
import logoimg from "../assets/logo.png"

const ResetSuccessfully = () => {
  return (
    <>
      <div className='back_Login'>
                <Container maxWidth="xl" className='login_container'>
                    <Box className='Login_image'>
                        <img src={heroimg} alt="images" />
                    </Box>
                    <Box className="form_Login">
                    <img src={logoimg} alt="" className='logo_login'/>
                    <Typography variant="h3">Your Password has been reset successfully!</Typography>
                        <Box>
                   <Link to="/Login">
                   <Button variant="contained" className='Login_btn'>
                      back to Sign in
                      </Button>
                   </Link>
                    </Box>

                    </Box>
                </Container>
            </div> 
    </>
  )
}

export default ResetSuccessfully
